module.exports = __webpack_public_path__ + "static/media/ServicesDataAnalyticsIcon.7632d6cd.svg";